<template>
  <div>
    <h2>最新心得</h2>
    <label style="color: blue">最近7天更新心得</label>
  </div>
  <div class="container" v-viewer="{ movable: false }">
    <label style="color: red">點圖可放大，表格可往右滑</label>
    <ModalCom1 :spa="commSpa" :name="commName"></ModalCom1>
    <viewer>
      <el-table
        :data="tableItem"
        border
        style="width: 100%"
        header-cell-class-name="my-header"
        :height="tableHeight"
      >
        <el-table-column
          v-for="column in columns"
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
          :width="column.width"
          :fixed="column.fixed"
          :sortable="column.sortable"
        >
          <template #default="scope">
            <img :src="scope.row[column.prop]" v-if="column.show" style="width: 100%" />
            <span v-html="scope.row[column.prop]" v-if="column.html" />
            <span v-html="format1(scope)" v-if="column.prop === 'name'" />
            <span v-if="column.prop === 'name'">{{ scope.row.name }}</span>
            <span v-if="column.prop === 'name' && scope.row.commCount > 0"><br /></span>
            <button
              v-if="column.prop === 'name' && scope.row.commCount > 0"
              type="button"
              class="btn btn-outline-primary btn-sm"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              @click="doButton(scope.row.spa_id, scope.row.name)"
            >
              心得{{ scope.row.commCount }}
            </button>
          </template>
        </el-table-column>
      </el-table>
    </viewer>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import ModalCom1 from "@/components/ModalCom1.vue";

export default {
  components: {
    ModalCom1,
  },
  data() {
    return {
      tableUrl: "/php/spa_table.php",
      configUrl: "/php/spa_config.php",
      spaConfig: [],
      spaList: [
        { id: "spa_01", name: "含香", value: "" },
        { id: "spa_02", name: "爵仕堡", value: "" },
      ],
      columns: [
        { prop: "image", label: "照片", show: true, fixed: "left", width: "120px" },
        {
          prop: "name",
          label: "姓名",
          show: false,
          sortable: true,
          fixed: "left",
          width: "90px",
        },
        {
          prop: "work_time",
          label: "可約時段",
          show: false,
          sortable: true,
          width: "150px",
        },
        { prop: "price", label: "台費", show: false, sortable: true, width: "90px" },
        { prop: "height", label: "身高", show: false, sortable: true, width: "90px" },
        { prop: "weight", label: "體重", show: false, sortable: true, width: "90px" },
        { prop: "cup", label: "罩杯", show: false, sortable: true, width: "90px" },
        {
          prop: "info",
          label: "介紹",
          show: false,
          sortable: true,
          html: true,
          width: "200px",
        },
      ],
      tableItem: [],
      tableHeight: 0,
      commSpa: "",
      commName: "",
      commentData: [],
    };
  },
  methods: {
    selectAll() {
      axios
        .post(this.configUrl, {
          action: "selectAll",
        })
        .then((res) => {
          this.spaConfig = res.data;

          this.spaList.splice(0);
          for (var i = 0; i < res.data.length; i++) {
            var item = res.data[i];

            var spa = {
              id: item.id,
              name: item.name,
              value: false,
            };
            this.spaList.push(spa);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async selectLastComment() {
      var now = new Date();
      now.setDate(now.getDate() - 7);
      var day = now.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      var month = now.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var year = now.getFullYear();
      var date = year + "-" + month + "-" + day;
      await axios
        .post(this.tableUrl, {
          action: "selectLastComment",
          date: date,
        })
        .then((res) => {
          this.commentData = res.data;
        })
        .catch((error) => {
          console.error(error);
        });
      this.doSearch();
    },
    format1(row) {
      if (1 == row.cellIndex && "true" == row.row.day_push) {
        return '<img src="https://imgf.gg9453.com/images/hot.png" height="30" width="60"></span><br>';
        //return row.row.name + '<span class="bi bi-hand-thumbs-up red-thumbs"></span>';
      }

      if (1 == row.cellIndex && "true" == row.row.is_new) {
        return '<img src="https://imgf.gg9453.com/images/new2.png" height="30" width="60"></span><br>';
        //return row.row.name + '<span class="bi bi-stars yellow-stars"></span>';
      }
    },
    async doSearch() {
      this.tableItem.splice(0);
      //console.log("spaList="+JSON.stringify(this.spaList));
      console.log("commentData =" + JSON.stringify(this.commentData));

      for (var j = 0; j < this.commentData.length; j++) {
        var tempSpa = this.commentData[j];
        await this.selectSpa(tempSpa.spa, tempSpa.name);
        console.log("selectSpa =" + tempSpa.spa + " " + tempSpa.name);
      }
    },
    async selectSpa(spaId, name) {
      await axios
        .post(this.tableUrl, {
          action: "searchCommentByName",
          table_name: spaId,
          name: name,
        })
        .then((res) => {
          if (res.data.length > 0) {
            var findSpaName = this.spaConfig.find((e) => e.id === spaId);
            for (var i = 0; i < res.data.length; i++) {
              var item = res.data[i];
              item.image = "https://imgf.gg9453.com/images/spa_daily/" + item.image;
              item.spa_name = findSpaName.name;
              var ex = "";
              if (item.music == "true") {
                ex += "、送音樂";
              }

              if (item.bento) {
                ex += "、套餐" + item.bento;
              }
              ex = ex.substring(1);
              item.ex = ex;
              item.spa_id = spaId;

              if (item.name_his) {
                item.info = item.info + "<br>" + item.name_his;
              }

              var week = "";
              if (item.w1) {
                week += "一" + item.w1 + "<br>";
              }
              if (item.w2) {
                week += "二" + item.w2 + "<br>";
              }
              if (item.w3) {
                week += "三" + item.w3 + "<br>";
              }
              if (item.w4) {
                week += "四" + item.w4 + "<br>";
              }
              if (item.w5) {
                week += "五" + item.w5 + "<br>";
              }
              if (item.w6) {
                week += "六" + item.w6 + "<br>";
              }
              if (item.w7) {
                week += "日" + item.w7 + "<br>";
              }
              item.week = week;

              this.tableItem.push(item);
              console.log("tableItem =" + JSON.stringify(this.tableItem));
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    doButton(spa1, name1) {
      this.commSpa = spa1;
      this.commName = name1;
      console.log("doButton=" + this.commSpa + " " + this.commName);
    },
  },
  created: function () {
    this.selectAll();
    this.tableHeight = window.innerHeight - 300;
    if (this.tableHeight < 500) {
      this.tableHeight = 500;
    }

    if (window.innerWidth < 600) {
      this.columns = [
        { prop: "image", label: "照片", show: true, fixed: "left", width: "65px" },
        {
          prop: "name",
          label: "姓名",
          show: false,
          sortable: true,
          fixed: "left",
          width: "85px",
        },
        {
          prop: "work_time",
          label: "可約時段",
          show: false,
          sortable: true,
          width: "120px",
        },
        {
          prop: "week",
          label: "當周報班",
          show: false,
          sortable: false,
          html: true,
          width: "150px",
        },
        {
          prop: "spa_name",
          label: "店家",
          show: false,
          sortable: true,
          width: "80px",
        },
        { prop: "price", label: "台費", show: false, sortable: true, width: "70px" },
        { prop: "height", label: "身高", show: false, sortable: true, width: "70px" },
        { prop: "weight", label: "體重", show: false, sortable: true, width: "70px" },
        { prop: "cup", label: "罩杯", show: false, sortable: true, width: "70px" },
        {
          prop: "info",
          label: "介紹",
          show: false,
          sortable: true,
          html: true,
          width: "300px",
        },
        {
          prop: "ex",
          label: "額外服務",
          show: false,
          sortable: true,
          html: true,
          width: "200px",
        },
      ];
    } else {
      var w = "100px";
      if (this.conWidth) {
        w = this.conWidth - 200 - 450 - 200 - 32 + "px";
      }
      this.columns = [
        { prop: "image", label: "照片", show: true, fixed: "left", width: "200px" },
        {
          prop: "name",
          label: "姓名",
          show: false,
          sortable: true,
          fixed: "left",
          width: "120px",
        },
        {
          prop: "work_time",
          label: "可約時段",
          show: false,
          sortable: true,
          width: "200px",
        },
        {
          prop: "week",
          label: "當周報班",
          show: false,
          sortable: false,
          html: true,
          width: "150px",
        },
        { prop: "price", label: "台費", show: false, sortable: true, width: "90px" },
        {
          prop: "spa_name",
          label: "店家",
          show: false,
          sortable: true,
          width: "90px",
        },
        { prop: "height", label: "身高", show: false, sortable: true, width: "90px" },
        { prop: "weight", label: "體重", show: false, sortable: true, width: "90px" },
        { prop: "cup", label: "罩杯", show: false, sortable: true, width: "90px" },
        {
          prop: "info",
          label: "介紹",
          show: false,
          sortable: true,
          html: true,
          width: "270px",
        },
        {
          prop: "ex",
          label: "額外服務",
          show: false,
          sortable: true,
          html: true,
          width: "200px",
        },
      ];
    }
  },
  mounted() {
    this.selectLastComment();
  },
};
</script>

<style>
.form-check label {
  margin-left: 4px;
  margin-top: 4px;
  font-size: 18px;
  font-weight: 500;
}
.form-check .form-check-input[type="checkbox"] {
  border-radius: 0.25em;
  height: 25px;
  width: 25px;
}

.my-header {
  background: black !important;
  border-color: black !important;
  font-size: 16px;
  color: white;
}

.el-table__body-wrapper {
  z-index: 2;
}

.el-table__fixed,
.el-table__fixed-right {
  box-shadow: none;
}

.el-table__fixed,
.el-table__fixed-right {
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    content: "";
    z-index: 100;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
  }
}

.el-table .cell {
  font-size: 18px;
  white-space: pre-line;
  overflow: unset;
}
</style>
